import React, { useState } from "react"
import PropTypes from "prop-types"
import SingleDatePicker from "react-dates/lib/components/SingleDatePicker"
import { ICON_AFTER_POSITION } from "react-dates/lib/constants.js"
import moment from "moment"
import "react-dates/initialize"
import "react-dates/lib/css/_datepicker.css"
import "./react-dates.css"

import { handleWeekDays } from "../DateRangePicker/utils/handleWeekDays"

import Calendar from "../../assets/svg/calendar-green.svg"

moment.locale("pt-br")

const Icon = () => {
  return <img src={Calendar} alt="Calendário" />
}

const SingleDate = ({
  anchorDirection,
  openDirection,
  date,
  onDateChange,
  id,
  disabled,
  isDayBlocked
}) => {
  const [focused, setFocused] = useState(null)

  const onFocusChange = ({ focused }) => setFocused(focused)

  return (
    <div className="singleDate">
      <SingleDatePicker
        id={id}
        date={date}
        focused={focused}
        onDateChange={onDateChange}
        onFocusChange={onFocusChange}
        placeholder="00/00/0000"
        required
        small
        inputIconPosition={ICON_AFTER_POSITION}
        anchorDirection={anchorDirection}
        openDirection={openDirection}
        disabled={disabled}
        customInputIcon={<Icon />}
        hideKeyboardShortcutsPanel
        renderDayContents={handleWeekDays}
        isDayBlocked={isDayBlocked}
      />
    </div>
  )
}

SingleDate.propTypes = {
  anchorDirection: PropTypes.string,
  openDirection: PropTypes.string,
  date: PropTypes.string,
  onDateChange: PropTypes.func,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  isDayBlocked: PropTypes.func
}

export default SingleDate



// WEBPACK FOOTER //
// ./src/components/SingleDatePicker/index.js